export default "__VITE_ASSET__D1kLmDa4__"